export const RESOLUTION_FLOW_MODALS_NAMES = {
  bundledServicesActiveModal: 'bundledServicesActiveModal',
}
